import { useEffect } from 'react'
import { useFilterStore } from '../stores/useFilterStore'

export const useNodePinning = () => {
    const pinnedNodes = useFilterStore(state => state.pinnedNodes)
    const setPinnedNodes = useFilterStore(state => state.setPinnedNodes)

    useEffect(() => {
        if (!window.myEventEmitter) {
            return
        }

        const onClickNodeListener = receivedData => {
            const receivedPinnedNodes = receivedData.nodes

            const dashedPinnedNodes = receivedPinnedNodes.map(node => {
                return node.replace(' ', '_')
            })

            setPinnedNodes(dashedPinnedNodes)
        }

        myEventEmitter.on('pinnedNodes', onClickNodeListener)

        return () => {
            if (window.myEventEmitter) {
                myEventEmitter.removeListener(
                    'pinnedNodes',
                    onClickNodeListener
                )
            }
        }
    }, [pinnedNodes])
}
